export default __webpack_public_path__ + "media/images/messagecards/birthday-a946a322d73b90e8b03eb93ed292b19a.jpg";